<template>
    <Modal
        v-model="show"
        :mask-closable="false"
        :loading="loading"
        :width="1000"
        class="infomodal-wrapper"
        @on-ok="confirmHander"
        @on-cancel="cancelHander">
        <div slot="header" class="modal-header">{{title}}</div>
        <Form
            :model="form"
            :rules="formRules"
            ref="form">
            <template v-if="edit">
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                        <FormItem
                            label="来源渠道"
                            prop="projectFid">
                            <Input v-model="form.sourceName" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem
                            label="物业负责人"
                            prop="name">
                            <Input v-model="form.name" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem
                            label="物业负责人电话"
                            prop="phone">
                            <Input v-model="form.phone" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
                <template v-if="form.source === 2">
                    <!-- 一键推楼 -->
                    <Row
                        :gutter="16"
                        class="mb16">
                        <Col :span="8">
                            <FormItem
                                label="推荐人"
                                prop="refereeName">
                                <Input v-model="form.refereeName" readonly></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem
                                label="推荐人电话"
                                prop="refereeMobile">
                                <Input v-model="form.refereeMobile" readonly></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem
                                label="推荐人大区"
                                prop="refereeDept">
                                <Input v-model="form.refereeDept" readonly></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
                <template v-else-if="form.source === 3">
                    <!-- 城市巡展  -->
                    <Row
                        :gutter="16"
                        class="mb16">
                        <Col :span="8">
                            <FormItem
                                label="公司"
                                prop="company">
                                <Input v-model="form.company" readonly></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem
                                label="职位"
                                prop="job">
                                <Input v-model="form.job" readonly></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem
                                label="邮箱"
                                prop="email">
                                <Input v-model="form.email" readonly></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
                <Row
                    :gutter="16"
                    class="mb16">
                   <Col :span="8">
                      <FormItem
                        label="地址"
                        prop="address">
                        <Input v-model="form.address"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem
                            label="面积"
                            prop="areas">
                            <Select v-model="form.areas">
                                <Option value="">请选择</Option>
                                <Option v-for="(item,index) in form.areaList" :key="index" :value="item.value">{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem
                            label="楼层"
                            prop="floors">
                                <Select v-model="form.floors">
                                    <Option value="">请选择</Option>
                                    <Option v-for="(item,index) in form.floorList" :key="index" :value="item.value">{{item.text}}</Option>
                                </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                      <FormItem
                        label="产权性质"
                        prop="propertyRights">
                        <Select v-model="form.propertyRights">
                          <Option value="">请选择</Option>
                          <Option v-for="(item,index) in form.propertyRightList" :key="index" :value="item.value">{{item.text}}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col :span="8">
                      <FormItem
                        label="物业类型"
                        prop="propertyType">
                        <Select v-model="form.propertyType" @on-change="getCooperationModeMap">
                          <Option value="">请选择</Option>
                          <Option v-for="(item,index) in form.propertyTypeList" :key="index" :value="item.value">{{item.text}}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem
                            label="意向合作方式"
                            prop="cooperationMode">
                           <Select v-model="form.cooperationMode">
                                <Option value="">请选择</Option>
                                <Option v-for="(item,index) in cooperationModeList" :key="index" :value="item.value">{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="24">
                        <FormItem
                            label="其他信息"
                            prop="remark">
                            <Input v-model="form.remark" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                        <FormItem
                            label="处理结果"
                            prop="handleStatus">
                            <Select v-model="form.handleStatus">
                                <Option value="">请选择</Option>
                                <Option v-for="(item,index) in form.status" :key="index" :value="item.value">{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="24">
                        <FormItem
                            label="跟进记录"
                            prop="handleRecord">
                            <Input v-model="form.handleRecord" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </template>
            <template v-else>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                        <FormItem label="来源渠道：">{{form.sourceName}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="物业负责人：">{{form.name}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="物业负责人电话：">{{form.phone}}</FormItem>
                    </Col>
                </Row>
                <template v-if="form.source === 2">
                    <!-- 一键推楼 -->
                     <Row
                        :gutter="16"
                        class="mb16">
                        <Col :span="8">
                            <FormItem label="推荐人：">{{form.refereeName}}</FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem label="推荐人电话：">{{form.refereeMobile}}</FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem label="推荐人大区：">{{form.refereeDept}}</FormItem>
                        </Col>
                    </Row>
                </template>
                <template v-else-if="form.source === 3">
                    <!-- 成熟巡展 -->
                    <Row
                        :gutter="16"
                        class="mb16">
                        <Col :span="8">
                            <FormItem label="公司：">{{form.company}}</FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem label="职位：">{{form.job}}</FormItem>
                        </Col>
                        <Col :span="8">
                            <FormItem label="邮箱：">{{form.email}}</FormItem>
                        </Col>
                    </Row>
                </template>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                        <FormItem label="地址：">{{form.address}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="面积：">{{form.areaName}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="楼层：">{{form.floorName}}</FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="8">
                       <FormItem label="产权性质：">{{form.propertyRightsName}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="物业类型：">{{form.propertyTypeName}}</FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="意向合作方式：">{{form.cooperationModeName}}</FormItem>
                    </Col>
                </Row>
                <Row
                    :gutter="16"
                    class="mb16">
                    <Col :span="24">
                        <FormItem label="其他信息：">{{form.remark}}</FormItem>
                    </Col>
                </Row>
            </template>
            <table-list
                title="历史记录"
                :columns="columns"
                :loading="false"
                :showPage="false"
                :height="form.handleLogList.length === 0 ? null : form.handleLogList.length <= 5 ? null : 300"
                :data="form.handleLogList"></table-list>
        </Form>
    </Modal>
</template>

<script type="text/ecmascript-6">
import TableList from 'components/TableList';
import { getApartmentDetailByFid,handleCooperation } from "@/api/ownerShip";
export default {
    name:"INFOMODAL",
    props:{
        value:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default:'处理商机'
        },
        edit:{
            type:Boolean,
            default:true
        },
        id:{
            type:String,
            default:null
        }
    },
    components: {
        TableList
    },
    data () {
        return {
            show:false,
            loading:true,
            form:{
                sourceName:null,
                name:null,
                phone:null,
                refereeName:null,
                refereeMobile:null,
                refereeDept:null,
                areas:null,
                floors:null,
                propertyRights:null,
                propertyRightsName:null,
                address:null,
                cooperationMode:null,
                cooperationModeName:null,
                remark:null,
                handleLogList:[],
                company:null,
                job:null,
                email:null,
                handleStatus:null,
                status:[],
                fid:null,
                handleRecord:null,
                propertyRightList:[],
                cooperationModeList:[],
                areaList:[],
                floorList:[],
                areaName:null,
                floorName:null,
                propertyType:null,
                propertyTypeList:[],
                propertyTypeName:null
            },
            formRules:{
                handleStatus:[
                    { required: true, message: '请选择处理结果' ,trigger: 'change', type:'number'}
                ],
                handleRecord:[
                    { required: true, message: '请填写跟进记录' ,trigger: 'blur', type:'string'}
                ]
            },
            columns: [
                {
                    type: "index",
                    width: 60,
                    align: "center"
                },
                {
                    title: "操作人",
                    align: "center",
                    key: "handleName"
                },
                {
                    title: "操作时间",
                    align: "center",
                    key: "handleTime"
                },
                {
                    title: "处理结果",
                    align: "center",
                    key: "handleResult"
                },
                {
                    title: "跟进记录",
                    align: "center",
                    key: "handleRecord"
                },
            ],
            cooperationModeList: []
        }
    },
    watch: {
        value(val) {
            if(val){
                this.init();
            }
            this.show = val;
        },
        show(val) {
            if(!val){
                this.initData();
            }
            this.$emit('input',val)
        }
    },
    methods: {
        confirmHander() {
            if(!this.edit){
                this.show = false
                return;
            }
             this.$refs['form'].validate(bool => {
                 if(!bool){
                    this.changeLoading();
                    return;
                 }
                this.form.fid = this.id;
                handleCooperation(this.form).then(res => {
                    this.$Message.success('处理商机成功');
                    this.$emit('refresh');
                    this.show = false;
                    this.changeLoading();
                })
                .catch(error => {
                    this.changeLoading();
                })
             })
        },
        cancelHander() {
            this.show = false
        },
        init() {
            getApartmentDetailByFid({fid:this.id}).then(res => {
                const cooperationMode = res.data.cooperationMode
                this.form = res.data;
                setTimeout(() => {
                    this.getCooperationModeMap(this.form.propertyType, false)
                    this.form.cooperationMode = cooperationMode
                }, 100)
            })
        },
        initData() {
            Object.keys(this.form).forEach(item => {
                if(item === 'handleLogList' || item === 'status'){
                    this.form[item] = [];
                }else{
                    this.form[item] = null;
                }
            })
            this.$refs['form'].resetFields();
        },
        changeLoading() {
            this.loading = false;
            this.$nextTick(() => {
                this.loading = true
            })
        },
        getCooperationModeMap (val, clean = true) {
            if (clean) {
                this.cooperationModeList = []
                this.form.cooperationMode = ''
            }
            if (this.form.cooperationModeMap) {
                this.cooperationModeList = this.form.cooperationModeMap[val]
            }
        }
    }
}
</script>

<style lang="css">
.infomodal-wrapper .ivu-modal-body{
    height: 500px;
    overflow: auto;
}
</style>
